// src/constants/serviceTypes.js

// Complete service types matching backend schema
export const SERVICE_TYPES = {
  // Trades & Construction
  APPLIANCE_REPAIR: 'Appliance Repair',
  AUTO_BODY_REPAIR: 'Auto Body Repair',
  BAKERY: 'Bakery',
  BARBER: 'Barber',
  BEAUTY_SALON: 'Beauty Salon',
  CAR_WASH_DETAILING: 'Car Wash & Detailing',
  CARPENTER: 'Carpenter',
  CATERING: 'Catering',
  CHILDCARE: 'Childcare',
  CLEANER: 'Cleaner',
  COFFEE_SHOP: 'Coffee Shop',
  CONSULTANT: 'Consultant',
  CULINARY_CLASSES: 'Culinary Classes',
  DELIVERY_SERVICE: 'Delivery Service',
  DIGITAL_MARKETING: 'Digital Marketing',
  DJ_ENTERTAINMENT: 'DJ & Entertainment',
  ELDER_CARE: 'Elder Care',
  ELECTRICIAN: 'Electrician',
  EVENT_PLANNER: 'Event Planner',
  FITNESS_TRAINER: 'Fitness Trainer',
  FLOORING_SPECIALIST: 'Flooring Specialist',
  FOOD_CATERER: 'Food Caterer',
  FOOD_DELIVERY: 'Food Delivery',
  FOOD_TRUCK: 'Food Truck',
  GRAPHIC_DESIGNER: 'Graphic Designer',
  HAIRDRESSER: 'Hairdresser',
  HANDYMAN: 'Handyman',
  HVAC_TECHNICIAN: 'HVAC Technician',
  ICE_CREAM_PARLOR: 'Ice Cream Parlor',
  INTERIOR_DESIGNER: 'Interior Designer',
  IT_SUPPORT: 'IT Support',
  JEWELRY_REPAIR: 'Jewelry Repair',
  JUICE_BAR: 'Juice Bar',
  LANDSCAPER: 'Landscaper',
  LANGUAGE_INSTRUCTOR: 'Language Instructor',
  LAUNDRY_SERVICE: 'Laundry Service',
  LOCKSMITH: 'Locksmith',
  MAKEUP_ARTIST: 'Makeup Artist',
  MASON: 'Mason',
  MEAL_PREP_SERVICE: 'Meal Prep Service',
  MECHANIC: 'Mechanic',
  MOVING_COMPANY: 'Moving Company',
  NAIL_TECHNICIAN: 'Nail Technician',
  NOTARY_PUBLIC: 'Notary Public',
  OTHER: 'Other',
  PAINTER: 'Painter',
  PARTY_RENTALS: 'Party Rentals',
  PASTRY_SHOP: 'Pastry Shop',
  PEST_CONTROL: 'Pest Control',
  PET_GROOMING: 'Pet Grooming',
  PET_SITTING: 'Pet Sitting',
  PHOTOGRAPHER: 'Photographer',
  PLUMBER: 'Plumber',
  POOL_MAINTENANCE: 'Pool Maintenance',
  RESTAURANT: 'Restaurant',
  SHOE_REPAIR: 'Shoe Repair',
  SOLAR_INSTALLER: 'Solar Installer',
  SPA_MASSAGE_THERAPIST: 'Spa & Massage Therapist',
  STORAGE_SERVICES: 'Storage Services',
  TAILOR: 'Tailor',
  TILER: 'Tiler',
  TOUR_GUIDE: 'Tour Guide',
  TRANSLATION_SERVICES: 'Translation Services',
  TRANSPORTATION: 'Transportation',
  TUTOR: 'Tutor',
  VIDEOGRAPHER: 'Videographer',
  WEB_DEVELOPER: 'Web Developer',
  WEDDING_PLANNER: 'Wedding Planner',
  YOGA_INSTRUCTOR: 'Yoga Instructor'
};

// All service types as an array (alphabetical)
export const SERVICE_TYPES_ARRAY = [
  'Appliance Repair',
  'Auto Body Repair',
  'Bakery',
  'Barber',
  'Beauty Salon',
  'Car Wash & Detailing',
  'Carpenter',
  'Catering',
  'Childcare',
  'Cleaner',
  'Coffee Shop',
  'Consultant',
  'Culinary Classes',
  'Delivery Service',
  'Digital Marketing',
  'DJ & Entertainment',
  'Elder Care',
  'Electrician',
  'Event Planner',
  'Fitness Trainer',
  'Flooring Specialist',
  'Food Caterer',
  'Food Delivery',
  'Food Truck',
  'Graphic Designer',
  'Hairdresser',
  'Handyman',
  'HVAC Technician',
  'Ice Cream Parlor',
  'Interior Designer',
  'IT Support',
  'Jewelry Repair',
  'Juice Bar',
  'Landscaper',
  'Language Instructor',
  'Laundry Service',
  'Locksmith',
  'Makeup Artist',
  'Mason',
  'Meal Prep Service',
  'Mechanic',
  'Moving Company',
  'Nail Technician',
  'Notary Public',
  'Other',
  'Painter',
  'Party Rentals',
  'Pastry Shop',
  'Pest Control',
  'Pet Grooming',
  'Pet Sitting',
  'Photographer',
  'Plumber',
  'Pool Maintenance',
  'Restaurant',
  'Shoe Repair',
  'Solar Installer',
  'Spa & Massage Therapist',
  'Storage Services',
  'Tailor',
  'Tiler',
  'Tour Guide',
  'Translation Services',
  'Transportation',
  'Tutor',
  'Videographer',
  'Web Developer',
  'Wedding Planner',
  'Yoga Instructor'
];

// Service type categories for organization
export const SERVICE_CATEGORIES = {
  AUTOMOTIVE: {
    label: 'Automotive',
    types: [
      SERVICE_TYPES.AUTO_BODY_REPAIR,
      SERVICE_TYPES.CAR_WASH_DETAILING,
      SERVICE_TYPES.MECHANIC,
    ]
  },
  BEAUTY_PERSONAL_CARE: {
    label: 'Beauty & Personal Care',
    types: [
      SERVICE_TYPES.BARBER,
      SERVICE_TYPES.BEAUTY_SALON,
      SERVICE_TYPES.HAIRDRESSER,
      SERVICE_TYPES.MAKEUP_ARTIST,
      SERVICE_TYPES.NAIL_TECHNICIAN,
      SERVICE_TYPES.SPA_MASSAGE_THERAPIST,
    ]
  },
  EDUCATION_WELLNESS: {
    label: 'Education & Wellness',
    types: [
      SERVICE_TYPES.CHILDCARE,
      SERVICE_TYPES.ELDER_CARE,
      SERVICE_TYPES.FITNESS_TRAINER,
      SERVICE_TYPES.LANGUAGE_INSTRUCTOR,
      SERVICE_TYPES.TUTOR,
      SERVICE_TYPES.YOGA_INSTRUCTOR,
    ]
  },
  FOOD_BEVERAGE: {
    label: 'Food & Beverage',
    types: [
      SERVICE_TYPES.BAKERY,
      SERVICE_TYPES.CATERING,
      SERVICE_TYPES.COFFEE_SHOP,
      SERVICE_TYPES.CULINARY_CLASSES,
      SERVICE_TYPES.FOOD_CATERER,
      SERVICE_TYPES.FOOD_DELIVERY,
      SERVICE_TYPES.FOOD_TRUCK,
      SERVICE_TYPES.ICE_CREAM_PARLOR,
      SERVICE_TYPES.JUICE_BAR,
      SERVICE_TYPES.MEAL_PREP_SERVICE,
      SERVICE_TYPES.PASTRY_SHOP,
      SERVICE_TYPES.RESTAURANT,
    ]
  },
  HOME_SERVICES: {
    label: 'Home Services',
    types: [
      SERVICE_TYPES.APPLIANCE_REPAIR,
      SERVICE_TYPES.CLEANER,
      SERVICE_TYPES.INTERIOR_DESIGNER,
      SERVICE_TYPES.LANDSCAPER,
      SERVICE_TYPES.LOCKSMITH,
      SERVICE_TYPES.PEST_CONTROL,
      SERVICE_TYPES.POOL_MAINTENANCE,
    ]
  },
  OTHER_SERVICES: {
    label: 'Other Services',
    types: [
      SERVICE_TYPES.DELIVERY_SERVICE,
      SERVICE_TYPES.JEWELRY_REPAIR,
      SERVICE_TYPES.LAUNDRY_SERVICE,
      SERVICE_TYPES.MOVING_COMPANY,
      SERVICE_TYPES.OTHER,
      SERVICE_TYPES.SHOE_REPAIR,
      SERVICE_TYPES.STORAGE_SERVICES,
      SERVICE_TYPES.TAILOR,
      SERVICE_TYPES.TOUR_GUIDE,
      SERVICE_TYPES.TRANSPORTATION,
    ]
  },
  PET_SERVICES: {
    label: 'Pet Services',
    types: [
      SERVICE_TYPES.PET_GROOMING,
      SERVICE_TYPES.PET_SITTING,
    ]
  },
  PROFESSIONAL_SERVICES: {
    label: 'Professional Services',
    types: [
      SERVICE_TYPES.CONSULTANT,
      SERVICE_TYPES.DIGITAL_MARKETING,
      SERVICE_TYPES.DJ_ENTERTAINMENT,
      SERVICE_TYPES.EVENT_PLANNER,
      SERVICE_TYPES.GRAPHIC_DESIGNER,
      SERVICE_TYPES.IT_SUPPORT,
      SERVICE_TYPES.NOTARY_PUBLIC,
      SERVICE_TYPES.PARTY_RENTALS,
      SERVICE_TYPES.PHOTOGRAPHER,
      SERVICE_TYPES.TRANSLATION_SERVICES,
      SERVICE_TYPES.VIDEOGRAPHER,
      SERVICE_TYPES.WEB_DEVELOPER,
      SERVICE_TYPES.WEDDING_PLANNER,
    ]
  },
  TRADES_CONSTRUCTION: {
    label: 'Trades & Construction',
    types: [
      SERVICE_TYPES.CARPENTER,
      SERVICE_TYPES.ELECTRICIAN,
      SERVICE_TYPES.FLOORING_SPECIALIST,
      SERVICE_TYPES.HANDYMAN,
      SERVICE_TYPES.HVAC_TECHNICIAN,
      SERVICE_TYPES.MASON,
      SERVICE_TYPES.PAINTER,
      SERVICE_TYPES.PLUMBER,
      SERVICE_TYPES.SOLAR_INSTALLER,
      SERVICE_TYPES.TILER,
    ]
  }
};

// Get all category labels (alphabetical)
export const SERVICE_CATEGORY_LABELS = Object.values(SERVICE_CATEGORIES)
  .map(cat => cat.label)
  .sort();

// Get all service types as a flat array (same as SERVICE_TYPES_ARRAY)
export const ALL_SERVICE_TYPES = SERVICE_TYPES_ARRAY;

// Helper function to get service type by category
export const getServiceTypesByCategory = (categoryLabel) => {
  const category = Object.values(SERVICE_CATEGORIES).find(
    cat => cat.label === categoryLabel
  );
  return category ? category.types : [];
};

// Helper function to get category for a service type
export const getCategoryForServiceType = (serviceType) => {
  for (const [key, category] of Object.entries(SERVICE_CATEGORIES)) {
    if (category.types.includes(serviceType)) {
      return category.label;
    }
  }
  return null;
};

// Helper to check if a service type is valid
export const isValidServiceType = (serviceType) => {
  return SERVICE_TYPES_ARRAY.includes(serviceType);
};

// Helper to get display name (with translation support)
export const getServiceTypeDisplayName = (serviceType) => {
  // This is a simple mapping - you can extend this with your translation system
  const displayNames = {
    [SERVICE_TYPES.BEAUTY_SALON]: 'Beauty Salon',
    [SERVICE_TYPES.RESTAURANT]: 'Restaurant',
    [SERVICE_TYPES.CATERING]: 'Catering',
    [SERVICE_TYPES.PLUMBER]: 'Plumber',
    [SERVICE_TYPES.ELECTRICIAN]: 'Electrician',
    // Add more as needed
  };
  return displayNames[serviceType] || serviceType;
};

// For backward compatibility - matches your original serviceTypes array
export const LEGACY_SERVICE_TYPES = [
  'Appliance Repair',
  'Auto Body Repair',
  'Bakery',
  'Barber',
  'Beauty Salon',
  'Car Wash & Detailing',
  'Carpenter',
  'Catering',
  'Childcare',
  'Cleaner',
  'Coffee Shop',
  'Consultant',
  'Culinary Classes',
  'Delivery Service',
  'Digital Marketing',
  'DJ & Entertainment',
  'Elder Care',
  'Electrician',
  'Event Planner',
  'Fitness Trainer',
  'Flooring Specialist',
  'Food Caterer',
  'Food Delivery',
  'Food Truck',
  'Graphic Designer',
  'Hairdresser',
  'Handyman',
  'HVAC Technician',
  'Ice Cream Parlor',
  'Interior Designer',
  'IT Support',
  'Jewelry Repair',
  'Juice Bar',
  'Landscaper',
  'Language Instructor',
  'Laundry Service',
  'Locksmith',
  'Makeup Artist',
  'Mason',
  'Meal Prep Service',
  'Mechanic',
  'Moving Company',
  'Nail Technician',
  'Notary Public',
  'Other',
  'Painter',
  'Party Rentals',
  'Pastry Shop',
  'Pest Control',
  'Pet Grooming',
  'Pet Sitting',
  'Photographer',
  'Plumber',
  'Pool Maintenance',
  'Restaurant',
  'Shoe Repair',
  'Solar Installer',
  'Spa & Massage Therapist',
  'Storage Services',
  'Tailor',
  'Tiler',
  'Tour Guide',
  'Translation Services',
  'Transportation',
  'Tutor',
  'Videographer',
  'Web Developer',
  'Wedding Planner',
  'Yoga Instructor'
];

// Export default for easy importing
export default {
  SERVICE_TYPES,
  SERVICE_TYPES_ARRAY,
  SERVICE_CATEGORIES,
  SERVICE_CATEGORY_LABELS,
  ALL_SERVICE_TYPES,
  getServiceTypesByCategory,
  getCategoryForServiceType,
  isValidServiceType,
  getServiceTypeDisplayName,
  LEGACY_SERVICE_TYPES
};